import {
  UPDATE_TOKEN,
  UPDATE_USER_INFO,
  UPDATE_PERMISSIONS,
  UPDATE_SELECT
} from './mutation-types'
import * as api from 'bzmj/api'
export default {
  [UPDATE_TOKEN]: ({ commit }) => api.getToken().then(token => {
    commit(UPDATE_TOKEN, token)
    return token
  }),
  /**
   * 更新用户信息
   */
  [UPDATE_USER_INFO]: ({ commit }) => api.getUserInfo().then(data => {
    const { user, permissions } = data
    commit(UPDATE_USER_INFO, user)
    commit(UPDATE_PERMISSIONS, permissions)
    return data
  }),
  [UPDATE_SELECT.BUSINESS_TYPE]: ({ commit }) => api.common.getBusinessType().then(data => {
    commit(UPDATE_SELECT.BUSINESS_TYPE, data)
    return data
  }),
  [UPDATE_SELECT.CHILD_TASK_TYPE]: ({ commit }) => api.common.getChildTaskTypeAndName({}, 'store.childtasktype').then(data => {
    commit(UPDATE_SELECT.CHILD_TASK_TYPE, data.taskType)
    return data.taskType
  }),
  [UPDATE_SELECT.ABNORMAL_CATEGORY]: ({ commit }) => api.common.getAbnormalSelect().then(data => {
    commit(UPDATE_SELECT.ABNORMAL_CATEGORY, data.category)
    return data.category
  })
}
